import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			flex: 1,
			width: '100%',
			marginBottom: 'auto',
			'& > label': {
				color: 'rgba(255, 255, 255, 0.4)',
			},
		},
		margin: {
			margin: theme.spacing(1),
		},
		textfield: {
			'-webkit-animation-name': 'autofill',
			'-webkit-animation-fill-mode': 'both',
			color: '#fff!important',
		},
		textfieldRoot: {
			'&:before': {
				borderColor: 'rgba(255, 255, 255, 0.4)!important',
				borderWidth: 1,
			},
			'&:after': {
				borderColor: 'rgba(255, 255, 255, 0.8)',
				borderWidth: 1,
			},
		},
		shortTextIcon: {
			'& path:nth-child(2)': {
				stroke: 'none',
				fill: 'rgba(255, 255, 255, 0.6)',
			},
		},
		editIcon: {
			color: 'rgba(255, 255, 255, 0.52)',
			'& > g > path': {
				stroke: 'none',
				fill: 'rgba(255, 255, 255, 0.6)',
			},
		},
		validIcon: {
			'& > g > path': {
				stroke: 'none',
				fill: 'rgba(255, 255, 255, 0.6)',
			},
		},
		showPasswordIconOn: {
			color: 'rgba(255, 255, 255, 0.8)',
			'& path:nth-child(2)': {
				stroke: 'none',
				fill: 'rgba(255, 255, 255, 0.8)',
			},
		},
		showPasswordIconOff: {
			color: 'rgba(255, 255, 255, 0.8)',
			'& path:nth-child(2)': {
				stroke: 'none',
				fill: 'rgba(255, 255, 255, 0.4)',
			},
		},
		adornment: {
			width: 14,
			height: 14,
			'& path': {
				color: 'rgba(255, 255, 255, 0.5)',
			},
			'& g:not(:first-child) > path': {
				fill: '#fff',
			},
			'& > path:nth-child(2)': {
				fill: '#fff',
			},
		},
	})
